import { render, staticRenderFns } from "./LogoFull.vue?vue&type=template&id=13887564&scoped=true"
import script from "./LogoFull.vue?vue&type=script&lang=ts"
export * from "./LogoFull.vue?vue&type=script&lang=ts"
import style0 from "./LogoFull.vue?vue&type=style&index=0&id=13887564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13887564",
  null
  
)

export default component.exports